(ns dre.pages.my-searches.tags.utils
  (:require [clojure.string :as str]
            [dre.app.invert-color :refer [invert-color]]
            [dre.components.icon :refer [fa-icon]]
            [dre.components.tooltip :refer [tooltip-wrapper]]
            [dre.i18n.events :as-alias i18n]
            [dre.utils :refer [user-id]]
            [re-frame.core :as rf]))
 
(defn tag-pill
  [{:keys [:owner :name :color]} user & {:keys [inline-style?]}]
  (let [style (cond-> {:font-weight 700}
                (not (str/blank? color))
                (assoc :background-color (str color)
                       :color (str (invert-color color true))))]
    [:div.pills-container
     [:span.item.label.pill.utag 
     {:style style}
     [:span
      (when inline-style? ;; Added this flag because it applies wrong styles in suggestion dropdown
        {:style style})
      [fa-icon :hashtag
       {:style style}]
      [:span
       (when (and owner (not= owner (user-id user)))
         [tooltip-wrapper owner [:span
                                 [fa-icon :user]]])]
      [:span
       {:style style}
       (or name
           [tooltip-wrapper "Unresolved tag" [fa-icon :warning
                                              {:style {:color "rgb(119, 0, 0)"}}]])]]]]))

(defn tag-of-current-user? [user tag]
  (= (:owner tag) (get user :user-id)))
